// Exams.tsx - Clean minimal version

import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useIntl } from 'react-intl'
import { useTabs, TabsConfig } from '@hooks/useTabs'
import Procedures from './Procedures'
import ExamTypes from './ExamTypes'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import CategoryIcon from '@mui/icons-material/Category'
import MultistepProtocols from './MultistepProtocols'
import { Assignment, AssignmentReturned, Layers, Topic } from '@mui/icons-material'
import DmpPublishTasksList from './DmpBackgroundTask'
import DmpSubmissions from './DmpSubmittions'

const getExamsConfig = (intl: ReturnType<typeof useIntl>): TabsConfig => ({
  procedures: {
    id: 'procedures',
    label: intl.formatMessage({ id: 'procedures' }),
    component: Procedures,
  },
  examTypes: {
    id: 'examTypes',
    label: intl.formatMessage({ id: 'examTypes' }),
    component: ExamTypes,
  },
  multistepProtocols: {
    id: 'multistepProtocols',
    label: intl.formatMessage({ id: 'multistepProtocols' }),
    component: MultistepProtocols,
  },
  DmpBackgroundTask: {
    id: 'dmp-background-task',
    label: intl.formatMessage({ id: 'dmp-background-task' }),
    component: DmpPublishTasksList,
  },
  // dmpSubmission: {
  //   id: 'dmp-submission',
  //   label: intl.formatMessage({ id: 'dmp-background-task' }),
  //   component: DmpSubmissions,
  // },
})

const tabIcons = {
  procedures: LocalHospitalIcon,
  examTypes: CategoryIcon,
  multistepProtocols: Layers,
  DmpBackgroundTask:Topic,
  // dmpSubmission:AssignmentReturned
}

export default function Exams() {
  const intl = useIntl()
  const config = getExamsConfig(intl)
  const { keys, index, onChange, Component } = useTabs(config)

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Tab Bar */}
      <Box
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'grey.200',
          px: 4,
        }}
      >
        <Tabs
          value={index[0]}
          onChange={onChange[0]}
          aria-label="exams-tabs"
          sx={{
            '& .MuiTabs-indicator': {
              height: 2,
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              minHeight: 48,
              mr: 4,
              px: 0,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'primary.main',
              },
            },
          }}
        >
          {keys.map((key) => {
            const Icon = tabIcons[key as keyof typeof tabIcons]
            return (
              <Tab
                key={key}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {Icon && <Icon sx={{ fontSize: 18 }} />}
                    {config[key].label}
                  </Box>
                }
                id={`tab-${key}`}
                aria-controls={`tabpanel-${key}`}
              />
            )
          })}
        </Tabs>
      </Box>

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: '#f9fafb',
          p: 2,
        }}
      >
        {Component && <Component />}
      </Box>
    </Box>
  )
}